<script setup>
import UiAvatar from './UiAvatar.vue';

// Avatar + name (+ a muted second line) for people in tables, lists and
// dialog headers.
defineProps({
  name: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  src: { type: String, default: '' },
  size: { type: Number, default: 32 },
});
</script>

<template>
  <span class="ui-person">
    <UiAvatar :name="name" :src="src" :size="size" />
    <span class="ui-person__text">
      <span class="ui-person__name">{{ name }}</span>
      <span v-if="subtitle || $slots.subtitle" class="ui-person__subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </span>
    </span>
  </span>
</template>

<style scoped>
.ui-person {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 4px 0;
}
.ui-person__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.3;
}
.ui-person__name {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui-person__subtitle {
  font-size: 12px;
  color: var(--muted-foreground);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
